import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ProjectsDataService} from '../projects-data.service';
import {ModalDismissReasons, NgbAlert, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {IAlert} from '../../ngbootstrap/alert/alert.component';
import {ClientsDataService} from '../../clients/clients-data.service';
import {Options} from 'select2';
import {DropdownDataTable} from '../../../shared/dropdown-data.table';
import {Router} from '@angular/router';


@Component({
    selector: 'app-projects-list',
    templateUrl: './projects-list.component.html',
    styleUrls: ['./projects-list.component.scss'],
    providers: [DropdownDataTable]
})
export class ProjectsListComponent implements OnInit {

    projectsData: any = [];
    newStatus: string;
    closeResult: string;

    private _success = new Subject<string>();
    private _error = new Subject<string>();

    successMessage = '';
    errorMessage = '';

    formResponse: boolean;
    formSent: boolean;

    staticAlertClosed = false;
    @ViewChild('selfClosingAlert', {static: false}) selfClosingAlert: NgbAlert;
    @ViewChild('selfClosingError', {static: false}) selfClosingError: NgbAlert;

    clientsArray: any;
    clientsNameArray: any = [];
    dataLoaded: boolean;

    public singleSelect: Options;

    size: number = 3;
    pageSizes = [3, 6, 9];
    page: number = 1;
    totalElements: number;

    order: string;
    sort: string;

    projectData: any = [];

    projectName: string;
    projectNumber: string;
    clientName: string;
    projectStatus: string;

    sortingValues = this.dropdownSelect.projectsSorting;

    newProjectStatus: string = undefined;


    constructor(private projectsService: ProjectsDataService,
                private modalService: NgbModal,
                private router: Router,
                private clientService: ClientsDataService,
                private dropdownSelect: DropdownDataTable) {
    }

    ngOnInit(): void {
        this.singleSelect = {
            width: '100%',
            multiple: false,
            allowClear: true
        }

        this.clientService.getAllCompanies().subscribe(companies => {
            this.clientsArray = companies;
            this.clientsArray.forEach((value) => {
                this.clientsNameArray.push({id: value.companyName, text: value.companyName});
            });

            this.dataLoaded = true;
        })

        this.getProjects();
        this._success.subscribe(message => this.successMessage = message);
        this._success.pipe(debounceTime(5000)).subscribe(() => {
            if (this.selfClosingAlert) {
                this.selfClosingAlert.close();
            }
        });

        this._error.subscribe(message => this.errorMessage = message);
        this._error.pipe(debounceTime(5000)).subscribe(() => {
            if (this.selfClosingError) {
                this.selfClosingError.close();
            }
        });
    }

    createJobAfterProject(projectId) {
        this.formSent = false;
        this.projectsService.createJobAfterProject(projectId).subscribe((res: any) => {
            this.formResponse = true;
            this.formSent = true;

            setTimeout(() => {
                this.router.navigate([`/sistemerp/joburi/editeaza-job/${res.reason}`])
            }, 4000)
        }, error => {
            this.formResponse = false;
            this.formSent = true;
        })
    }

    public changeSuccessMessage(message: string) {
        this._success.next(message);
    }

    public changeErrorMessage(message: string) {
        this._error.next(message);
    }

    openSmall(content) {
        this.newProjectStatus = undefined;
        this.modalService.open(content, {centered: true});
    }

    getProjects() {

        this.projectData = {
            name: this.projectName !== '' ? this.projectName : undefined,
            docNumber: this.projectNumber !== '' ? this.projectNumber : undefined,
            clientName: this.clientName !== '' ? this.clientName : undefined,
            status: this.projectStatus !== '' ? this.projectStatus : undefined
        }

        this.projectsService.getProjects(this.page, this.size, this.sort, this.order, this.projectData).subscribe(projects => {
            
            this.projectsData = projects['content'];
            this.totalElements = projects['totalElements'];
            console.log(this.projectsData, this.totalElements)
        })
    }

    changeStatus(projectId: string, projectNumber: string, status: string) {
        if (status === 'activ') {
            this.newStatus = 'arhivat';
            this.projectsService.changeStatus(projectId, this.newStatus).subscribe(resp => {
                this.getProjects();
                this.changeSuccessMessage('Statusul proiectului ' + projectNumber + ' a fost schimbat in arhivat!');

            }, error => {
                this.changeErrorMessage('Eroare! Statusul nu a fost schimbat!');

            });
        } else if (status === 'arhivat') {
            this.newStatus = 'activ';
            this.projectsService.changeStatus(projectId, this.newStatus).subscribe(resp => {
                    this.getProjects();
                    this.changeSuccessMessage('Statusul proiectului ' + projectNumber + ' a fost schimbat in activ!');
                },
                error => {
                    this.changeErrorMessage('Eroare! Statusul nu a fost schimbat!');

                });
        }
    }

    onPageChange(page: number) {
        this.page = page;
        this.getProjects();
    }


    onSizeChange(event: any) {
        this.size = event.target.value;
        this.page = 1;
        this.getProjects();
    }

    onSortChange(event: any) {
        this.sort = event.target.value;
        this.page = 1;
        this.getProjects();
    }

    onOrderChange(event: any) {
        this.order = event.target.value;
        this.page = 1;
        this.getProjects();
    }

    changeProjectStatus(projectId: string, newProjectStatus: string) {
        this.projectsService.changeStatus(projectId, newProjectStatus).subscribe(res => {
            this.getProjects();
            this.newProjectStatus = undefined;
            this.successMessage = 'Statusul a fost schimbat cu success!';
            setTimeout(() => {
                this.successMessage = ''
            }, 5000)
        }, error => {
            this.errorMessage = "Ceva nu a functionat. Te rugam sa mai incerci.";
            setTimeout( () => {this.errorMessage = ''}, 5000)
        })
    }


}
